/*
 * BioIndex
 * Copyright (c) 2026 BioIndex™. All rights reserved.
 * Unauthorized copying, scraping, redistribution, or commercial reuse is prohibited.
 */

export default function ProfileTaxonomicCoverage({
  isOwnProfile,
  stats,
  sectionLoading,
  sectionProgress,
  SectionRefreshOverlay,
  StatLine,
  getTaxonItems,
  setTaxonViewLabel,
  setTaxonViewItems,
  setTaxonViewOpen,
}) {
  if (!stats) return null;

  return (
    <div className="lg:col-span-4 relative bg-white rounded-3xl shadow-lg border border-[#93ca87]/40 p-8">
      <SectionRefreshOverlay
        show={sectionLoading.taxonomy}
        progress={sectionProgress.taxonomy}
        label="Refreshing taxonomy"
      />

      <h2 className="bioindex-profile-panel-heading mb-5">Taxonomic Coverage</h2>

      {stats.totalSpecies === 0 ? (
        <div className="text-sm text-slate-400 italic text-center py-10">
          {isOwnProfile
            ? "You currently have no species. Add photos to start building your taxonomic coverage."
            : "This user currently has no species."}
        </div>
      ) : (
        <div className="space-y-4">
          <StatLine
            label="Kingdoms"
            data={stats.counts.kingdom}
            onClick={() => {
              setTaxonViewLabel("Kingdoms");
              setTaxonViewItems(getTaxonItems("kingdom"));
              setTaxonViewOpen(true);
            }}
          />

          <StatLine
            label="Phyla"
            data={stats.counts.phylum}
            onClick={() => {
              setTaxonViewLabel("Phyla");
              setTaxonViewItems(getTaxonItems("phylum"));
              setTaxonViewOpen(true);
            }}
          />

          <StatLine
            label="Classes"
            data={stats.counts.class}
            onClick={() => {
              setTaxonViewLabel("Classes");
              setTaxonViewItems(getTaxonItems("class"));
              setTaxonViewOpen(true);
            }}
          />

          <StatLine
            label="Orders"
            data={stats.counts.order}
            onClick={() => {
              setTaxonViewLabel("Orders");
              setTaxonViewItems(getTaxonItems("order"));
              setTaxonViewOpen(true);
            }}
          />

          <StatLine
            label="Families"
            data={stats.counts.family}
            onClick={() => {
              setTaxonViewLabel("Families");
              setTaxonViewItems(getTaxonItems("family"));
              setTaxonViewOpen(true);
            }}
          />

          <StatLine
            label="Genera"
            data={stats.counts.genus}
            onClick={() => {
              setTaxonViewLabel("Genera");
              setTaxonViewItems(getTaxonItems("genus"));
              setTaxonViewOpen(true);
            }}
          />

          <StatLine
            label="Species"
            value={stats.totalSpecies}
            onClick={() => {
              setTaxonViewLabel("Species");
              setTaxonViewItems(getTaxonItems("species"));
              setTaxonViewOpen(true);
            }}
          />
        </div>
      )}
    </div>
  );
}
